// First, we need to import the FlatList and other React Native component
import React, { memo, useCallback } from "react";
import { FlatList, StyleSheet } from "react-native";
// We also need to add the connectInfiniteHits connector to our import
import { connectInfiniteHits } from "react-instantsearch-native";

import UserNewMessageSearch from "./UserNewMessageSearch";

const styles = StyleSheet.create({
  contentContainerFlatList: {
    paddingBottom: 100,
  },
  flatList: {
    width: "100%",
  },
});

const MessageHits = connectInfiniteHits(
  ({
    hits,
    hasMore,
    refine,
    onPressResult,
    userId,
    isCoachingCampaign,
    coachId,
  }) => {
    /* if there are still results, you can
  call the refine function to load more */
    const onEndReached = function () {
      if (hasMore) {
        refine();
      }
    };

    const keyExtractor = useCallback((item, index) => {
      return item.objectID;
    }, []);

    const handlePressResult = useCallback(
      item => () => {
        onPressResult(item);
      },
      [],
    );

    const renderItem = useCallback(({ item, index }) => {
      // only display coach if coachingAccount

      if (isCoachingCampaign && coachId) {
        if (item._id !== coachId) return;
      }
      // only display different users
      if (item._id === userId) {
        return;
      }

      if (item.name) {
        return (
          <UserNewMessageSearch
            index={index}
            handlePressResult={handlePressResult(item)}
            name={item?.name}
            picture={item?.picture}
          />
        );
      }
    }, []);

    return (
      <FlatList
        initialNumToRender={10}
        data={hits}
        onEndReached={onEndReached}
        contentContainerStyle={styles.contentContainerFlatList}
        keyboardShouldPersistTaps="always"
        horizontal={false}
        style={styles.flatList}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
      />
    );
  },
);

export default memo(MessageHits);
